import { render, staticRenderFns } from "./seat-summary.vue?vue&type=template&id=948987e2"
import script from "./seat-summary.vue?vue&type=script&lang=js"
export * from "./seat-summary.vue?vue&type=script&lang=js"
import style0 from "./seat-summary.vue?vue&type=style&index=0&id=948987e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports